import { motion } from 'framer-motion';

const useCases = [
  'Founders',
  'Consultants',
  'Agencies',
  'Creators',
  'Sales operators',
  'Personal brands',
  'B2B experts',
  'Fractional CMOs',
];

const duplicatedUseCases = [...useCases, ...useCases];

export function TrustedBy() {
  return (
    <section className="overflow-hidden border-b-2 border-border bg-background py-8">
      <div className="mx-auto mb-6 max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center text-xs font-black uppercase tracking-[0.3em] text-muted-foreground"
        >
          Built for people who sell through trust
        </motion.p>
      </div>

      <div className="relative">
        <div className="absolute bottom-0 left-0 top-0 z-10 w-24 bg-gradient-to-r from-background to-transparent" />
        <div className="absolute bottom-0 right-0 top-0 z-10 w-24 bg-gradient-to-l from-background to-transparent" />

        <motion.div
          className="flex gap-4"
          animate={{ x: [0, -900] }}
          transition={{ x: { repeat: Infinity, repeatType: 'loop', duration: 28, ease: 'linear' } }}
        >
          {duplicatedUseCases.map((name, idx) => (
            <motion.div
              key={`${name}-${idx}`}
              whileHover={{ y: -2 }}
              className="shrink-0 border-2 border-border bg-muted/50 px-5 py-3 text-sm font-black uppercase tracking-[0.16em]"
            >
              {name}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
